import React from 'react';
import { Hero } from '../components/Hero';
import { WhatYouGet } from '../components/WhatYouGet';
import { QuickTestimonials } from '../components/QuickTestimonials';
import { PainPoints } from '../components/PainPoints';
import { Transformation } from '../components/Transformation';
import { Method } from '../components/Method';
import { WhyOthersFail } from '../components/WhyOthersFail';
import { Story } from '../components/Story';
import { Testimonials } from '../components/Testimonials';
import { PurchaseSection } from '../components/PurchaseSection';
import { FAQ } from '../components/FAQ';
import { FinalCTA } from '../components/FinalCTA';
import { Footer } from '../components/Footer';
import { PurchaseNotification } from '../components/PurchaseNotification';
import { OfferBanner } from '../components/OfferBanner';
export function LandingPage() {
  return <>
      <main className="min-h-screen w-full overflow-x-hidden" data-id="element-661">
        <Hero data-id="element-662" />
        <WhatYouGet data-id="element-663" />
        <QuickTestimonials data-id="element-664" />
        <PainPoints data-id="element-665" />
        <Transformation data-id="element-666" />
        <Method data-id="element-667" />
        <WhyOthersFail data-id="element-668" />
        <Story data-id="element-669" />
        <Testimonials data-id="element-670" />
        <PurchaseSection data-id="element-671" />
        <FAQ data-id="element-672" />
        <FinalCTA data-id="element-673" />
        <Footer data-id="element-674" />
      </main>
      <PurchaseNotification data-id="element-675" />
      <OfferBanner data-id="element-676" />
    </>;
}